import React from 'react';
import Accordion from 'react-bootstrap/Accordion';
import Card from 'react-bootstrap/Card';
import SeriesTable from './SeriesTable';

const SeriesContainer = ({ name, series, workout, setTableTemp, table, ...props}) => {
  return (
    <div className="series-container">
      <Accordion defaultActiveKey="0">
        <Card className="series-accordion">
          <Accordion.Toggle as={Card.Header} eventKey="0">
            { name }
            <i className="fas fa-sort-down"></i>
          </Accordion.Toggle>
          <Accordion.Collapse eventKey="0">
            <Card.Body>
            <div>
              {
                Object.keys(series).map(exercise => {
                  return(
                    <SeriesTable key={exercise} setTableTemp={setTableTemp} workout={workout} series={name} table={table} tableTitle={exercise} exercises={series[exercise]}/>
                  )
                })
              }
            </div>
            </Card.Body>
          </Accordion.Collapse>
        </Card>
      </Accordion>
    </div>
  );
}

export default SeriesContainer;
